export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creazione widget per"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conto"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Genera"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagamento in"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Importo del pagamento"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azioni in caso di successo"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azioni in caso di insuccesso"])}
}